<template>
    <div class="ecr">
        <template v-if="!loaded">
            <h1 class="ecr__heading">
                <ellipsis></ellipsis>
            </h1>
        </template>
        <template v-else>
            <h1 class="ecr__heading">
                {{ $t('chooseRetailer.heading') }}
            </h1>

            <div class="ecr__select">
                <eda-styled-select
                        :legend="$t('chooseRetailer.select.heading')"
                        :selectedLegend="$t('chooseRetailer.select.legend')"
                        :searchable="true"
                        v-model="selectedRetailer"
                        :options="retailers">

                </eda-styled-select>
            </div>
            <div calss="ecr__submit">
                <eda-button @click="confirmUser()" :error="error" :loading="sendingRequest"
                            :disabled="!selectedRetailer.hasOwnProperty('id')">
                    {{ $t('chooseRetailer.submit') }}
                </eda-button>
            </div>

        </template>


    </div>

</template>

<script>
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';
    import Ellipsis from '../components/vEllipsisLoader';
    import EdaStyledSelect from '../components/vSelect';
    import EdaButton from '../components/vButton';
    import axios from 'axios';
    import apiMixin from '../mixins/apiMixin';


    export default {
        name: "EdaChooseRetailer",
        components: {
            EdaStyledSelect,
            Ellipsis,
            EdaButton,
        },
        mixins: [
            apiMixin.apiMixin
        ],
        props: {
            hash: {type: String, default: ""},
        },
        data: function () {
            return {
                error: false,
                retailers: [],
                selectedRetailer: {},
                errorMessage: "",
                loaded: false,
                sendingRequest: false,
            }
        },

        mounted() {

            this.setCurrentRetailer();

            var that = this;
            axios.get(process.env.VUE_APP_API_URL  + "/retailers/" + that.retailerGroupHandle, that.apiHeaders).then(function (response) {
                var response = response.data.data;

                for (var index in response) {
                    that.retailers.push(that.transformItem(response[index]))
                }
                that.loaded = true;
            }).catch(function (error) {
                console.log(error);
            });
        },

        computed: {
            ...mapGetters(["getUser"]),
        },

        methods: {

            ...mapActions([
                "setUser"
            ]),

            setCurrentRetailer() {

                var r = this.getUser.retailer;
                if (r && r.hasOwnProperty("id")) {
                    this.selectedRetailer = {label: r.name, id: r.id}
                }

            },

            transformItem(retailer) {
                return {label: retailer.name, id: retailer.id}
            },

            confirmUser() {
                var that = this;
                that.error = false;
                that.sendingRequest = true;
                axios.patch(process.env.VUE_APP_API_URL + "/users/me", {
                    "retailerPortals": [that.selectedRetailer.id],
                }, that.apiHeaders).then(function (response) {
                    that.setUser(response.data);
                    that.$router.push({path: '/cars'});

                }).catch(function (error) {
                    that.error = true;
                    that.errorMessage = error.response.data.error.message;
                    console.log(error.response)
                }).finally(function () {
                    that.loading = false;
                });
            }
        }
    }

</script>

<style>

    .ecr__heading {
        font-size: 1.3em;
        max-width: 20em;
        display: block;
        font-weight: 600;
    }

    .ecr {
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 1.1em;
        min-height: 60vh;
        color: white;
    }

    .ecr__select {
        width: 100%;
        max-width: 25em;
        padding-top: 1em;
        padding-bottom: 2em;
    }

    .ecr__code {
        padding-bottom: 2em;
    }

    .ecr__password,
    .ecr__username,
    .ecr__submit {
        padding: 0.5em;
        max-width: 20em;
        width: 100%;
    }

    .ecr__submit {
        padding-top: 1.5em;
        display: flex;
        justify-content: center;
        padding-bottom: 1em;
    }

    .ecr__submit--error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .ecr__form-element {
        padding: 1em 2em;
        width: 100%;
        border-radius: 3em;
        border: none;
        outline: none;
        font-weight: 600;
    }

    .ecr__input {
        color: white;
        background-color: #0E1A10;

    }

    .ecr__button {
        text-align: center;
        color: white;
        font-size: 1em;
        background-color: #00B27C;
    }

    .ecr__recover {
        width: 100%;
        max-width: 20em;
        padding: 0.5em 2em 2em 2em;
        text-align: left;
    }

    .ecr__forgot {
        font-size: 0.8em;
    }

    .ecr__login {
        padding-top: 1.2em;
        font-size: 0.8em;
    }

    .ecr__login-link {
        padding-left: 0.75em;
    }

    .ecr__link {
        color: #00B27C;
        font-weight: 300;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

</style>